import { FC, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/shared/lib';

/** Пункт списка в меню свёрнутого корневого элемента сайдбара */
export type SidebarFlyoutItem = {
  path: string;
  icon: ReactNode;
  label: ReactNode;
};

type Props = {
  item: SidebarFlyoutItem;
  /** Переход по пункту — меню закрывается */
  onNavigate: () => void;
};

/** Строка меню-подсказки свёрнутого элемента сайдбара: переход в раздел с подсветкой текущего. */
export const SidebarFlyoutLink: FC<Props> = ({ item, onNavigate }) => (
  <NavLink
    to={item.path}
    onClick={onNavigate}
    className={({ isActive }) =>
      cn(
        'flex items-center gap-2 rounded-md px-2 py-1.5 text-sm text-foreground',
        'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground',
        '[&>svg]:size-4 [&>svg]:shrink-0',
        isActive && 'bg-sidebar-accent text-sidebar-accent-foreground',
      )
    }
  >
    {item.icon}
    <span className={'truncate'}>{item.label}</span>
  </NavLink>
);
